import React from "react";
import { ActionIcon, useMantineTheme, Menu } from '@mantine/core';
import { IconAdjustmentsHorizontal } from '@tabler/icons-react';

import { utils } from "../../utils/globalVariables";
import { useDisplayModeContext } from "../../context/displayModeContext";

const DisplayModeSelector = () => {

    const theme = useMantineTheme();
    const { displayMode, handleSetDisplayModeContext } = useDisplayModeContext();

    return (
        <Menu
            shadow="md"
            width={135}
            position='bottom-start'
        >
            <Menu.Target>
                <ActionIcon
                    variant='light'
                    radius='xl'
                    title='Display Mode'
                    size='lg'
                >
                    <IconAdjustmentsHorizontal
                        size='1.125rem'
                        strokeWidth={1.25}
                        style={{
                            color: theme.colorScheme === 'light' ? '#000' : theme.colors.gray[0]
                        }}
                    />
                </ActionIcon>
            </Menu.Target>

            <Menu.Dropdown>
                <Menu.Item
                    onClick={() => {
                        handleSetDisplayModeContext(utils.displayMode.card.slug);
                    }}

                    sx={() => ({
                        textAlign: 'center',
                        backgroundColor: theme.colorScheme === 'light' ? (displayMode === utils.displayMode.card.slug ? theme.fn.rgba(theme.colors.blue[3], 0.25) : 'transparent') : (displayMode === utils.displayMode.card.slug ? theme.fn.rgba(theme.colors.blue[7], 0.25) : 'transparent'),
                    })}
                >
                    {utils.displayMode.card.caption} Mode
                </Menu.Item>

                <Menu.Divider />

                <Menu.Item
                    onClick={() => {
                        handleSetDisplayModeContext(utils.displayMode.table.slug);
                    }}

                    sx={() => ({
                        textAlign: 'center',
                        backgroundColor: theme.colorScheme === 'light' ? (displayMode === utils.displayMode.table.slug ? theme.fn.rgba(theme.colors.blue[3], 0.25) : 'transparent') : (displayMode === utils.displayMode.table.slug ? theme.fn.rgba(theme.colors.blue[7], 0.25) : 'transparent'),
                    })}
                >
                    {utils.displayMode.table.caption} Mode
                </Menu.Item>
            </Menu.Dropdown>
        </Menu>
    )
}

export default DisplayModeSelector;